import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 group-hover:text-primary-400 transition-colors">
                韩国漫画网
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              提供最新最全的韩漫在线免费阅读服务，支持下拉式免费阅读，为中文读者打造极致的韩国漫画阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">关于我们</Link></li>
              <li><a href="/about#contact" className="text-sm text-background-400 hover:text-background-100 transition-colors">联系我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-100 transition-colors">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-100 transition-colors">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">&copy; 2026 韩国漫画网. 韩漫在线免费看 - 韩漫免费漫画在线观看下拉式免费阅读</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="微博">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </div>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="微信">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line"></i>
              </div>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="QQ">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-qq-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}